(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var searchBtn = document.getElementById('searchbtn');
    var searchBar = document.getElementById('searchbar');
    var burger = document.getElementById('burger');
    var drawer = document.getElementById('drawer');

    if (!searchBtn || !searchBar) return;

    // Only one panel is ever open, so opening either closes the other.
    function toggle(button, panel, otherPanel, otherButton) {
      var open = panel.classList.toggle('open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) return;

      if (otherPanel) {
        otherPanel.classList.remove('open');
        otherButton.setAttribute('aria-expanded', 'false');
      }

      var input = panel.querySelector('input');
      if (input) input.focus();
    }

    function closeAll() {
      searchBar.classList.remove('open');
      searchBtn.setAttribute('aria-expanded', 'false');
      if (!drawer) return;
      drawer.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
    }

    searchBtn.addEventListener('click', function () {
      toggle(searchBtn, searchBar, drawer, burger);
    });

    if (burger && drawer) {
      burger.addEventListener('click', function () {
        toggle(burger, drawer, searchBar, searchBtn);
      });
      drawer.addEventListener('click', function (event) {
        if (event.target.tagName === 'A') closeAll();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.top')) closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    // Sorting is a plain form, so it works without this. The listener only
    // saves the extra click.
    var sort = document.getElementById('sort');
    if (sort) {
      sort.addEventListener('change', function () {
        sort.form.submit();
      });
    }

    var toggle = document.getElementById('truesize');
    var grid = document.getElementById('collection-grid');
    if (!toggle || !grid) return;

    // The choice holds while someone moves between categories, because the
    // reason to turn it on — comparing sizes — does not stop at one page.
    try {
      if (sessionStorage.getItem('truesize') === 'on') toggle.checked = true;
    } catch (e) {
      /* private browsing */
    }

    function apply() {
      grid.classList.toggle('grid--truesize', toggle.checked);
      try {
        sessionStorage.setItem('truesize', toggle.checked ? 'on' : 'off');
      } catch (e) {
        /* private browsing */
      }
    }

    toggle.addEventListener('change', apply);
    apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var form = document.getElementById('pdp-form');
    if (!form) return;

    var data = document.getElementById('pdp-variants');
    var variants = data ? JSON.parse(data.textContent) : [];
    var idInput = document.getElementById('pdp-variant-id');
    var priceEl = document.getElementById('pdp-price');
    var stockEl = document.getElementById('pdp-stock');
    var addBtn = document.getElementById('pdp-add');
    var strings = {
      add: addBtn ? addBtn.dataset.add : '',
      soldOut: addBtn ? addBtn.dataset.soldOut : '',
      inStock: stockEl ? stockEl.dataset.inStock : '',
      outStock: stockEl ? stockEl.dataset.outStock : ''
    };

    /* ---- gallery ---- */
    /* Replaced below once the variants are known. A product with one size
       has no picker, and clicking its thumbnails should still work. */
    var pickByMedia = function () {};

    var slides = [].slice.call(document.querySelectorAll('.gslide'));
    var thumbs = [].slice.call(document.querySelectorAll('.gth'));
    var tag = document.getElementById('gtag');

    function show(index) {
      if (index < 0 || index >= slides.length) return;
      slides.forEach(function (slide, i) {
        slide.hidden = i !== index;
        // A video left playing behind a photograph is the kind of thing
        // nobody notices until it is live.
        var video = slide.querySelector('video');
        if (video && i !== index) video.pause();
      });
      thumbs.forEach(function (other) {
        other.setAttribute('aria-current',
          Number(other.dataset.index) === index ? 'true' : 'false');
      });
      if (tag) tag.textContent = index + 1 + ' / ' + slides.length;
    }

    /* Pulled out of the thumbnail handler so choosing a size can call it too.
       The 250 ml and the 100 ml jars have the size printed on the lid, so
       showing one while the other is selected is not a subtle mismatch. */
    function showMedia(id) {
      if (!id) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.media) === String(id)) {
          show(i);
          return;
        }
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(Number(thumb.dataset.index));
        pickByMedia(thumb.dataset.media);
      });
    });

    /* ---- dry / wet ---- */
    document.querySelectorAll('.dwr').forEach(function (range) {
      var stage = range.closest('.dwstage');
      range.addEventListener('input', function () {
        stage.style.setProperty('--p', range.value + '%');
      });
    });

    /* ---- quantity ---- */
    var qty = document.getElementById('pdp-qty');
    document.querySelectorAll('.qty__step').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = Number(qty.value) + Number(button.dataset.step);
        qty.value = next < 1 ? 1 : next;
      });
    });

    /* ---- variants ---- */
    var pickers = [].slice.call(document.querySelectorAll('.var'));
    if (!pickers.length) return;

    /* Clicking a photograph chooses the size it shows, but only when that
       photograph belongs to exactly one size. On the sponges the same
       picture serves four sizes and quietly changing somebody's choice
       because they looked closer would be worse than doing nothing. */
    /* A variant holds one featured photograph, but a colour can have three:
       from above, from the side, the opening. Those others name their
       colour in the alt text ("Turbo Shell, Turquoise, from the side"), so
       a photograph that is nobody's featured one still chooses the variant
       whose name is one of its comma-separated parts, when exactly one is. */
    var altOf = {};
    [].slice.call(document.querySelectorAll('.gth[data-media]')).forEach(function (t) {
      altOf[t.dataset.media] = (t.dataset.alt || '').toLowerCase();
    });

    pickByMedia = function (id) {
      if (!id) return;
      var owners = variants.filter(function (v) {
        return String(v.media) === String(id);
      });
      if (owners.length === 0 && altOf[id]) {
        var parts = altOf[id].split(',').map(function (s) { return s.trim(); });
        owners = variants.filter(function (v) {
          return parts.indexOf(v.options.join(' ').toLowerCase()) !== -1;
        });
      }
      if (owners.length !== 1) return;

      var want = owners[0].options;
      pickers.forEach(function (button) {
        var position = Number(button.dataset.position) - 1;
        if (button.dataset.value === want[position]) {
          pickers.forEach(function (other) {
            if (other.dataset.position === button.dataset.position) {
              other.setAttribute('aria-checked', other === button ? 'true' : 'false');
            }
          });
        }
      });
      apply(owners[0], true);
    };

    function chosen() {
      var values = [];
      pickers.forEach(function (button) {
        if (button.getAttribute('aria-checked') === 'true') {
          values[Number(button.dataset.position) - 1] = button.dataset.value;
        }
      });
      return values;
    }

    function match(values) {
      return variants.filter(function (variant) {
        return variant.options.every(function (option, i) {
          return option === values[i];
        });
      })[0];
    }

    /* keepPhoto: the shopper chose the variant by clicking a photograph, so
       that photograph stays on screen. Without it, clicking the inside of
       the large abalone chose Large and then jumped straight back to the
       outside, Large's featured photograph, as if the click did nothing. */
    function apply(variant, keepPhoto) {
      if (!variant) return;

      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;

      if (stockEl) {
        stockEl.dataset.available = variant.available;
        stockEl.textContent = variant.available ? strings.inStock : strings.outStock;
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? strings.add : strings.soldOut;
      }

      if (!keepPhoto) showMedia(variant.media);

      document.querySelectorAll('.sit[data-variant]').forEach(function (item) {
        item.dataset.on = String(Number(item.dataset.variant) === variant.id);
      });

      // Keeps the address bar honest, so a shared link opens the size that
      // was actually on screen.
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    pickers.forEach(function (button) {
      button.addEventListener('click', function () {
        pickers.forEach(function (other) {
          if (other.dataset.position === button.dataset.position) {
            other.setAttribute('aria-checked', other === button ? 'true' : 'false');
          }
        });
        apply(match(chosen()));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reorder"]) return;
  try {
    
  (function () {
    var copy = document.getElementById('reorder-copy');
    if (copy) {
      copy.addEventListener('click', function () {
        var code = document.getElementById('reorder-code');
        if (!code || !navigator.clipboard) return;
        navigator.clipboard.writeText(code.textContent.trim()).then(function () {
          var was = copy.textContent;
          copy.textContent = copy.dataset.done;
          setTimeout(function () {
            copy.textContent = was;
          }, 2000);
        });
      });
    }

    var results = document.getElementById('reorder-results');
    if (!results) return;

    var cards = [].slice.call(results.querySelectorAll('.rpick'));
    var shapeButtons = [].slice.call(document.querySelectorAll('#q-shape .pick'));

    // Without this script every card stays visible, which is a fair answer
    // too: all four sponges, each a link to its page.
    function show(shape) {
      cards.forEach(function (card) {
        card.hidden = card.dataset.shape !== shape;
      });
    }

    shapeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        shapeButtons.forEach(function (other) {
          other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
        });
        show(button.dataset.shape);
      });
    });

    var first = shapeButtons.filter(function (button) {
      return button.getAttribute('aria-pressed') === 'true';
    })[0];
    if (first) show(first.dataset.shape);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sponge-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tabs = [].slice.call(document.querySelectorAll('.gtab'));
    if (!tabs.length) return;

    function select(tab) {
      tabs.forEach(function (other) {
        var on = other === tab;
        other.setAttribute('aria-selected', on ? 'true' : 'false');
        var panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        select(tab);
      });

      tab.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowDown' ? 1 : event.key === 'ArrowUp' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        var next = tabs[(index + step + tabs.length) % tabs.length];
        next.focus();
        select(next);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
